import React from 'react';

export const UserContext = React.createContext({});

export const PortalContext = React.createContext({});



// WEBPACK FOOTER //
// ./src/components/Common/Context.js